<template>
  <section class="item-education w-100">
    <div class="d-flex w-100">
      <div class="information">
        <h3>{{ item.title }}</h3>
        <h5>{{ item.major_level }} - {{ item.study_program }}</h5>
        <h5>{{ item.university }}, {{ item.location }}</h5>
        <h5>{{ item.year_start }} - {{ item.year_end }} | {{ item.age_calculate }} Tahun</h5>
        <h5>GPA {{ item.gpa }}</h5>
      </div>

      <div class="item-skill">
        <h3>Skill</h3>
        <div class="d-flex">
          <h5 v-for="(item,idx) in item.skills" :key="idx">{{ item.skill_name }}</h5>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props:{
      item: {},
    },
    data() {
      return {
        education : {
          title: 'S.kom',
          degree: 'S1',
          major: 'Teknik Informatika',
          school : 'Universitas Dian Nuswantoro',
          province : 'JAWA TENGAH',
          year_start : '2015',
          year_end : '2019',
          age_calculate : '4',
          gpa : '3.5'
        },
        skill : [
          'Social Media Marketing',
          'Social Media Marketing',
        ]
      };
    },
  };
</script>

<style lang="scss">
.item-education{
  align-self: baseline;
  padding: .7rem 1rem;
  border-left: 10px solid var(--theme-deafult);
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .d-flex{
    gap: 10px;
  }
  .information{
    flex: 1;
    h3{
      font-size: 1rem;
      color: var(--theme-deafult);
    }

    h5{
      font-size: .8rem;
      font-weight: 400;
    }
  }

  .item-skill{
    flex: 1;
    h3{
      font-size: 0.8rem;
      font-weight: 500;
    }

    .d-flex{
      flex-wrap: wrap;

      h5{
        padding: 0.2rem 1rem;
        background: var(--theme-deafult);
        color: var(--theme-font);
        font-size: 0.6rem;
        border-radius: 1rem !important;
        margin-bottom: 0;
      }
    }
  }
}
</style>
